import React from 'react'
import ReactDOM from 'react-dom/client'
import { MotionConfig } from 'framer-motion'
import { registerSW } from 'virtual:pwa-register';
import './shared/config/i18n/i18n';
import App from './App'
import './index.css'

// PWA auto-update (registerType: 'autoUpdate'): when a newly deployed service worker is
// detected, activate it and reload the page automatically — no manual unregister / hard
// refresh needed for users to get the latest build. State survives the reload (Zustand
// persist + project autosave). Importing virtual:pwa-register also suppresses the plugin's
// minimal auto-injected registerSW.js, so registration happens exactly once here.
registerSW({ immediate: true });

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      {/* reducedMotion="user" makes framer-motion honour prefers-reduced-motion
          app-wide: transform/layout/scale animations are skipped while opacity
          (crossfades) is kept. Complements the global CSS reset in index.css,
          which only covers CSS/tailwindcss-animate — framer runs on WAAPI.
          Context crosses React portals, so modals/toasts are covered too. */}
      <MotionConfig reducedMotion="user">
        <App />
      </MotionConfig>
    </React.StrictMode>
  );
}
